var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLocationFill = function SvgIconLocationFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.333A4.664 4.664 0 0 0 3.333 6c0 2.217 1.405 4.937 4.215 8.157a.599.599 0 0 0 .904 0c2.81-3.22 4.215-5.94 4.215-8.157A4.664 4.664 0 0 0 8 1.333zm0 6.334a1.668 1.668 0 1 1 .002-3.336A1.668 1.668 0 0 1 8 7.667z",
    fill: "var(--colors-brand)",
    fillRule: "evenodd"
  })));
};
export default SvgIconLocationFill;